import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Drawer } from 'primeng/drawer';
@Component({
  selector: 'shell-api-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [Drawer, RouterOutlet],
})
export class SidebarComponent {
  sidebarVisible = true;
  router = inject(Router);
  back() {
    this.router.navigate([
      '/',
      {
        outlets: {
          sidebar: null,
        },
      }
    ]);
  }
}
